import { forwardRef, type ReactElement, type Ref, type SVGProps } from 'react'

const DiamondIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
): ReactElement => (
  <svg
    width="27"
    height="22"
    viewBox="0 0 27 22"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M13.6669 21.2677C13.3869 21.2677 13.2002 21.1944 13.1069 21.0477L0.693546 5.72104C0.506879 5.50104 0.600213 5.20771 0.786879 5.06104L5.54688 0.954375C5.64021 0.807708 5.82688 0.734375 6.01355 0.734375H21.3202C21.5069 0.734375 21.6935 0.807708 21.8802 0.881042L26.6402 4.98771C26.8269 5.20771 26.9202 5.42771 26.7335 5.64771L14.2269 21.0477C14.1335 21.1944 13.9469 21.2677 13.6669 21.2677ZM2.18688 5.50104L13.6669 19.7277L25.1469 5.50104L20.9469 1.83437H6.38688L2.18688 5.50104Z"
    />
    <path
      d="M26.0201 6.11747H1.31443C1.03474 6.11747 0.755053 6.0386 0.661824 5.80198C0.568595 5.56536 0.568595 5.32874 0.755053 5.171L5.51005 0.970995C5.60328 0.813248 5.78974 0.734375 5.97619 0.734375H21.2657C21.4522 0.734375 21.6386 0.813248 21.8251 0.892122L26.5795 5.09212C26.7659 5.24987 26.7659 5.48649 26.6727 5.72311C26.5795 5.95973 26.2065 6.11747 26.0201 6.11747ZM2.80609 4.93437H24.342L20.8928 1.91747H6.34911L2.80609 4.93437Z"
    />
    <path
      d="M13.6666 20.3344C13.3848 20.3344 13.1029 20.1944 13.009 19.9844L5.30551 1.43437C5.21157 1.22437 5.30551 1.08437 5.39946 0.944375C5.58735 0.804375 5.77524 0.734375 5.96313 0.734375H21.3701C21.558 0.734375 21.8398 0.804375 21.9337 0.944375C22.0277 1.08437 22.1216 1.22437 22.0277 1.43437L14.3242 19.9844C14.2303 20.1944 13.9484 20.3344 13.6666 20.3344ZM6.90258 1.78437L13.6666 18.0244L20.4306 1.78437H6.90258Z"
    />
    <path
      d="M19.6402 6.17253H7.69353C7.41353 6.17253 7.13353 6.09375 7.0402 5.85743C6.94686 5.62111 6.94686 5.30602 7.22686 5.14847L13.2002 1.2041C13.4802 1.04655 13.8535 1.04655 14.1335 1.2041L20.1069 5.14847C20.2935 5.30602 20.3869 5.54234 20.2935 5.77866C20.2002 6.09375 19.9202 6.17253 19.6402 6.17253ZM9.5602 4.99093H17.8669L13.6669 1.91913L9.5602 4.99093Z"
    />
  </svg>
)

export default forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(DiamondIcon)
